import { Col, Input, Label, Row } from "reactstrap";
import Select from "../../Common/AppSelect";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createVehicle,
  createVehicleSuccess,
  getVehicleDetails,
  listVehicles,
  listVehicleStatus,
  listVehicleType,
  updateVehicle,
  updateVehicleSuccess,
} from "../../../store/vehicle/action";
import moment from "moment";
import { AppDatePicker } from "../../Common/AppDateTimePicker";
import handleDateTime, { handleDateFormat } from "../../Common/HandleDateTime";
import { toast } from "react-toastify";
import { getCustomersListData } from "../../../store/customers/action";
import AppModal from "../../Common/AppModal";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";

const CreateEditVehicle = ({ modal, toggle, isEdit, customerId }) => {
  const InitialData = {
    RegistrationPlate: "",
    Chassis: "",
    MinistryId: "",
    VehicleStatus_Id: "",
    VehicleType_Id: "",
    Title: null,
    Description: null,
    Notes: "",
    MileageValue: "",
    MileageValueDateTime: "",
    Customer_Id: customerId ?? "",
    Manufacturer: "",
    Model: "",
    ModelYear: "",
  };
  const [createEditData, setCreateEditData] = useState(InitialData);
  const dispatch = useDispatch();
  const {
    vehicleDetailsAPI,
    vehicleStatusListAPI,
    vehicleTypeListAPI,
    vehicleCreateAPI,
    vehicleUpdateAPI,
    vehicleCreateLoading,
    vehicleUpdateLoading,
    customersList,
  } = useSelector((state) => ({
    vehicleDetailsAPI: state.Vehicle.vehicleDetails?.vehicle_data,
    vehicleStatusListAPI: state.Vehicle.vehicleStatusList?.vehiclestatus_list,
    vehicleTypeListAPI: state.Vehicle.vehicleTypeList?.vehicletype_list,
    vehicleCreateAPI: state.Vehicle.vehicleCreate,
    vehicleUpdateAPI: state.Vehicle.vehicleUpdate,
    customersList: state.Customers?.customersDataList?.customer_list,
    vehicleCreateLoading: state.Vehicle.vehicleCreateLoading,
    vehicleUpdateLoading: state.Vehicle.vehicleUpdateLoading,
  }));

  useEffect(() => {
    dispatch(listVehicleStatus());
    dispatch(listVehicleType());
    dispatch(getCustomersListData());
    if (!isEdit) {
      setCreateEditData(InitialData);
    }
  }, []);

  const handleCreateUpdate = (updateCreate) => {
    if (updateCreate === "create") {
      dispatch(createVehicle([createEditData]));
    }
    if (updateCreate === "update") {
      dispatch(updateVehicle([createEditData]));
    }
  };

  useEffect(() => {
    if (isEdit) {
      setCreateEditData({
        Id: vehicleDetailsAPI?.Id,
        RegistrationPlate: vehicleDetailsAPI?.RegistrationPlate,
        Chassis: vehicleDetailsAPI?.Chassis,
        MinistryId: vehicleDetailsAPI?.MinistryId,
        VehicleStatus_Id: vehicleDetailsAPI?.VehicleStatus_Id,
        VehicleType_Id: vehicleDetailsAPI?.VehicleType_Id,
        Title: vehicleDetailsAPI?.Title,
        Description: vehicleDetailsAPI?.Description,
        Notes: vehicleDetailsAPI?.Notes,
        MileageValue: vehicleDetailsAPI?.MileageValue,
        MileageValueDateTime: vehicleDetailsAPI?.MileageValueDateTime,
        Customer_Id: vehicleDetailsAPI?.Customer_Id,
        Manufacturer: vehicleDetailsAPI?.Manufacturer,
        Model: vehicleDetailsAPI?.Model,
        ModelYear: vehicleDetailsAPI?.ModelYear,
      });
    }
  }, [vehicleDetailsAPI]);

  useEffect(() => {
    if (isEmpty(vehicleCreateAPI)) return;
    if (vehicleCreateAPI.status === 200) {
      dispatch(listVehicles());
      toast.success(vehicleCreateAPI?.message);
      toggle();
    } else {
      toast.error(vehicleCreateAPI?.message);
    }
    dispatch(createVehicleSuccess([]));
  }, [vehicleCreateAPI]);

  useEffect(() => {
    if (isEmpty(vehicleUpdateAPI)) return;
    if (vehicleUpdateAPI.status === 200) {
      dispatch(listVehicles());
      dispatch(getVehicleDetails({ id: vehicleDetailsAPI?.Id }));
      toast.success(vehicleUpdateAPI?.message);
      toggle();
    } else {
      toast.error(vehicleUpdateAPI?.message);
    }
    dispatch(updateVehicleSuccess([]));
  }, [vehicleUpdateAPI]);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={isEdit ? "Edit Vehicle" : "Create Vehicle"}
      icon={<DirectionsCarOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={vehicleCreateLoading || vehicleUpdateLoading}
      loadingText="Saving…"
      onSubmit={() => handleCreateUpdate(isEdit ? "update" : "create")}
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
    >
      <Row>
            <Col lg={12} className={"mt-2"}>
              <Label>Registration Plate</Label>
              <Input
                className={"form-control"}
                placeholder={"Registration Plate"}
                type="text"
                value={createEditData.RegistrationPlate}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    RegistrationPlate: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12}>
              <Label>Manufacturer</Label>
              <Input
                className={"form-control"}
                placeholder={"Manufacturer"}
                type="text"
                value={createEditData.Manufacturer}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Manufacturer: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12}>
              <Label>Model</Label>
              <Input
                className={"form-control"}
                placeholder={"Model"}
                type="text"
                value={createEditData.Model}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Model: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12}>
              <Label>Model Year</Label>
              <Input
                className={"form-control"}
                placeholder={"Model Year"}
                type="text"
                value={createEditData.ModelYear}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    ModelYear: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Chassis</Label>
              <Input
                className={"form-control"}
                placeholder={"Chassis"}
                type="text"
                value={createEditData.Chassis}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Chassis: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Ministry</Label>
              <Input
                className={"form-control"}
                placeholder={"Ministry"}
                type="text"
                value={createEditData.MinistryId}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    MinistryId: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12}>
              <Label>Customer</Label>
              <Select
                className={"w-100"}
                options={
                  !isEmpty(customersList)
                    ? customersList.map((item) => ({
                        label: item?.FullName,
                        value: item?.Id,
                      }))
                    : []
                }
                value={
                  createEditData.Customer_Id
                    ? {
                        label: customersList?.find(
                          (item) => item.Id === createEditData.Customer_Id
                        )?.FullName,
                        value: createEditData.Customer_Id,
                      }
                    : []
                }
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Customer_Id: e?.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Vehicle Status</Label>
              <Select
                className={"w-100"}
                options={
                  !isEmpty(vehicleStatusListAPI)
                    ? vehicleStatusListAPI.map((item) => ({
                        label: item?.Name,
                        value: item?.Id,
                      }))
                    : []
                }
                value={
                  createEditData.VehicleStatus_Id
                    ? [
                        {
                          label: vehicleStatusListAPI?.find(
                            (item) =>
                              item.Id === createEditData.VehicleStatus_Id
                          )?.Name,
                          value: createEditData.VehicleStatus_Id,
                        },
                      ]
                    : []
                }
                onChange={(e) => {
                  setCreateEditData({
                    ...createEditData,
                    VehicleStatus_Id: e?.value,
                  });
                }}
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Vehicle Type</Label>
              <Select
                className={"w-100"}
                options={
                  !isEmpty(vehicleTypeListAPI)
                    ? vehicleTypeListAPI.map((item) => ({
                        label: item?.Name,
                        value: item?.Id,
                      }))
                    : []
                }
                value={
                  createEditData.VehicleType_Id
                    ? {
                        label: vehicleTypeListAPI?.find(
                          (item) => item.Id === createEditData.VehicleType_Id
                        )?.Name,
                        value: createEditData.VehicleType_Id,
                      }
                    : []
                }
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    VehicleType_Id: e?.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Title</Label>
              <Input
                className={"form-control"}
                placeholder={"Title"}
                type="text"
                value={createEditData.Title}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Title: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Description</Label>
              <Input
                className={"form-control"}
                placeholder={"Description"}
                type="textarea"
                row={2}
                value={createEditData.Description}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Description: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Notes</Label>
              <Input
                className={"form-control"}
                placeholder={"Notes"}
                type="textarea"
                row={2}
                value={createEditData.Notes}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    Notes: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Mileage Value</Label>
              <Input
                className={"form-control"}
                placeholder={"Mileage Value"}
                type="text"
                value={createEditData.MileageValue}
                onChange={(e) =>
                  setCreateEditData({
                    ...createEditData,
                    MileageValue: e.target.value,
                  })
                }
              />
            </Col>
            <Col lg={12} className={"mt-2"}>
              <Label>Mileage Value Date Time</Label>
              <AppDatePicker
                value={
                  createEditData.MileageValueDateTime
                    ? moment(createEditData.MileageValueDateTime)
                    : null
                }
                onChange={(val) => {
                  const jsDate = val && val.isValid() ? val.toDate() : null;
                  setCreateEditData({
                    ...createEditData,
                    MileageValueDateTime: jsDate
                      ? handleDateFormat(jsDate)
                      : "",
                  });
                }}
              />
            </Col>
          </Row>
    </AppModal>
  );
};

export default CreateEditVehicle;
